import React from 'react';

import { Text } from '@lp/ds-next';

export const SuccessText = () => (
  <Text variant="bodyTextM">You can successfully close this organisation.</Text>
);
